module.exports = __webpack_public_path__ + "img/bench.261a6c64.png";